import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/experiments/:scenarioId");

export const Route = createFileRoute("/experiments/$scenarioId")({
  head: () => ({
    meta: [
      { title: "Scenario — LevelLoad" },
      {
        name: "description",
        content: "Overlay edits, run results and comparisons for one planning scenario.",
      },
      { property: "og:title", content: "Scenario — LevelLoad" },
      {
        property: "og:description",
        content: "Overlay edits, run results and comparisons for one planning scenario.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
